export const WhatsNewCount = 50;
